<template>
  <table-list
      ref="list"
      @query="handleLoadList"
      :request-params="{userNum: $route.query.num}"
      v-bind="$attrs"
      :data="tableData">
    <el-table-column align="center" :label="$t('日期')" prop="date" />
    <el-table-column align="center" :label="$t('早餐摄入量(kcal)')" prop="bfCalorie" />
    <el-table-column align="center" :label="$t('午餐摄入量(kcal)')" prop="lunchCalorie" />
    <el-table-column align="center" :label="$t('晚餐摄入量(kcal)')" prop="dinnerCalorie" />
    <el-table-column align="center" :label="$t('其他摄入量(kcal)')" prop="otherCalorie" />
    <el-table-column align="center" :label="$t('还可摄入量(kcal)')" prop="yesCalorie" />
    <el-table-column align="center" :label="$t('推荐摄入量(kcal)')" prop="recommendCalorie" />
    <el-table-column align="center" :label="$t('总摄入量(kcal)')" prop="allCalorie" />
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
export default {
  name: "DietRecord",
  components: {TableList},
  props: {
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.nutritionRecord.listMy, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
